<template>
    <Fragment>
        <Portal to="header-actions">
            <AntSwitch
                v-model="extraFilters.archived"
                class="mr-6"
                @change="fetchResources"
            >
                <Icon
                    slot="checkedChildren"
                    type="delete"
                />
                <Icon
                    slot="unCheckedChildren"
                    type="delete"
                />
            </AntSwitch>
            <AntButton
                icon="plus"
                type="primary"
                @click="$router.push({ name: 'measures.create' })"
            >
                {{ $t('add') }}
            </AntButton>
        </Portal>
        <Card>
            <MeasureTable
                :measures="measures"
                :pagination="pagination"
                :loading="loading"
                @change="fetchResources"
            />
        </Card>
    </Fragment>
</template>

<script>
import MeasureTable from '@/components/tables/MeasureTable.vue';
import { Button, Switch, Icon } from 'ant-design-vue';
import overviewMixin from '@/mixins/overviewMixin';

export default {
    name: 'MeasureOverview',
    components: {
        AntButton: Button,
        AntSwitch: Switch,
        MeasureTable,
        Icon,
    },
    mixins: [overviewMixin('measures')],
    data: () => ({
        extraFilters: {
            archived: false,
        },
    }),
};
</script>

<style></style>
